function parse_positive_number(value) {
    const parsed = Number(value || 0);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
}

export const first_non_empty_number = (...values) => {
    for (const value of values) {
        const parsed = parse_positive_number(value);
        if (parsed) {
            return parsed;
        }
    }
    return null;
};

export function parse_response_data(payload) {
    if (typeof payload !== "string") {
        const response_payload = payload;
        return response_payload;
    }
    const parsed_payload = parse_string_response_data(payload);
    return parsed_payload;
}

function parse_string_response_data(payload) {
    const trimmed = payload.trim();
    if (!trimmed) {
        const empty_payload = {};
        return empty_payload;
    }

    try {
        const parsed_payload = JSON.parse(trimmed);
        return parsed_payload;
    } catch (error) {
        const response_error = {
            status: "error",
            message: error?.message || "Invalid JSON response received from the server."
        };
        return response_error;
    }
}

function resolve_template_document_id(binding) {
    const template_document_id = first_non_empty_number(
        binding.template_document_id,
        binding.template_document?.id,
        binding.document_id,
        binding.template_id,
        binding.template
    );
    return template_document_id;
}

function resolve_template_document_entity_type_id(binding) {
    const template_document_entity_type_id = first_non_empty_number(
        binding.template_document_entity_type_id,
        binding.template_document_entity_type,
        binding.id
    );
    return template_document_entity_type_id;
}

function resolve_binding_url(binding) {
    const binding_url = binding.presigned_url || binding.document_url || binding.url || "";
    return binding_url;
}

function build_normalized_binding(binding, template_document_id, template_document_entity_type_id, binding_id, resolved_url) {
    const normalized_value_or_default = function normalized_value_or_default(primary, secondary, fallback) {
        const normalized_value = primary || secondary || fallback;
        return normalized_value;
    };
    const normalized_binding = {
        ...binding,
        id: binding_id,
        binding_id,
        template_id: template_document_id,
        template_document_id,
        template_document_entity_type_id,
        name: normalized_value_or_default(binding.document_name, binding.name, "Template"),
        type: normalized_value_or_default(binding.document_type, binding.type, "template"),
        url: resolved_url,
        presigned_url: resolved_url
    };
    return normalized_binding;
}

export const normalize_binding_record = (binding) => {
    const safe_binding = binding || {};
    const template_document_id = resolve_template_document_id(safe_binding);
    const template_document_entity_type_id = resolve_template_document_entity_type_id(safe_binding);
    const binding_id = first_non_empty_number(safe_binding.id, safe_binding.binding_id);
    const resolved_url = resolve_binding_url(safe_binding);

    const normalized_binding = build_normalized_binding(
        safe_binding,
        template_document_id,
        template_document_entity_type_id,
        binding_id,
        resolved_url
    );
    return normalized_binding;
};
